var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseX(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCloseX") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.4033812,35.0000475 L44.6133466,27.7900735 C45.2770326,27.1263868 45.2770326,26.0503407 44.6133466,25.3867489 C43.9496606,24.7230621 42.8737108,24.7230621 42.2100248,25.3867489 L34.9999644,32.5968178 L27.789904,25.386654 C27.126218,24.7229672 26.0502681,24.7229672 25.3865822,25.386654 C24.7229911,26.0503407 24.7229911,27.1263868 25.3865822,27.7899786 L32.5966426,34.9999525 L25.3865822,42.2100214 C24.7229911,42.8737082 24.7229911,43.9497542 25.3865822,44.613346 C26.0502681,45.2770328 27.126218,45.2770328 27.789904,44.613346 L34.9999644,37.4032772 L42.2100248,44.613346 C42.8736158,45.2770328 43.9496606,45.2770328 44.6133466,44.613346 C45.2770326,43.9496593 45.2770326,42.8737082 44.6133466,42.2100214 L37.4033812,35.0000475 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "popup---add-private-album---view-shared-images",
    transform: "translate(-1385.000000, -30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/icon/close-x",
    transform: "translate(1361.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/white",
    mask: "url(#mask-2)",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "colour/light-grey",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseX);
export default __webpack_public_path__ + "static/media/icCloseX.04e467d03d1c5972ec6df4165448bb3e.svg";
export { ForwardRef as ReactComponent };